import { Injectable } from "@angular/core";
import { PortalProductStrategy } from "./portal-product-strategy";
import { Observable, of } from "rxjs";
import { ProductKey } from "gast-common-ng2";

@Injectable()
export class ParticipantsBasedProductStrategyService extends PortalProductStrategy {
  availableProducts$: Observable<ProductKey[]> = of([]);
  availableProductsAsString$: Observable<string[]> = of([]);
  selectedProduct$: Observable<ProductKey> = of("GENERAL");
  selectedProductAsString$: Observable<string> = of("");

  updateCurrentProduct(productToSet: string): void {
    console.log(productToSet);
  }
}
